import cn from 'classnames';
import { FC, HTMLProps, ReactNode, useRef } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { useClickOutside } from '../../hooks/use-click-outside';
import { useKeyDown } from '../../hooks/use-key-down';
import { IconButton } from '../icon-button/icon-button';
import s from './modal.module.css';
import { LangSelect } from '../../features/lang-select/lang-select';

export interface ModalProps extends Omit<HTMLProps<HTMLDivElement>, 'title'> {
  onClose: () => void;
  title?: ReactNode;
  withLang?: boolean;
}

export const Modal: FC<ModalProps> = (props) => {
  const { children, onClose, title, className, withLang, ...other } = props;

  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, onClose);
  useKeyDown(ref, 'Escape', onClose);

  return (
    <dialog className={s.component}>
      <div className={cn(s.wrapper, className)} data-testid="modal" ref={ref} {...other}>
        {title && (
          <h4 className={cn(s.title, withLang && s.withLang)}>
            {title}
            {withLang && <LangSelect />}

            <IconButton
              className={s.close}
              onClick={onClose}
              variant="ghost"
              data-testid="modal-close"
            >
              <AiOutlineClose />
            </IconButton>
          </h4>
        )}
        {children}
      </div>
    </dialog>
  );
};
